import React from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Header from '../../toolbars/Header';

export default function StaticBox({ children, ...props }) {
  return (
    <React.Fragment>
      <Header
        clear={() => this.content.clearSelection()}
        version={props.version}
        setLoading={props.setLoading}
        handleMessage={props.handleMessage}
        error={props.error}
        setError={props.setError}>
      </Header>

      <Box sx={{
        position: 'absolute',
        top: '64px',
        bottom: '0',
        left: '0',
        right: '0',
      }}>
        <Paper
          sx={{
            position: 'absolute',
            top: '8px',
            bottom: '64px',
            left: '8px',
            right: '8px',
          }}>
          {children}
        </Paper>
      </Box>
    </React.Fragment>
  );
}
